import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from '../../services/api';
import { Moon, Sun } from '@gravity-ui/icons';
import { useAuth } from '../../hooks/useAuth';
import { THEMES, useTheme } from '../../utils/theme';
import { OFERTA_PDF_PATH } from '../../constants/offers';
import NotificationBell from '../NotificationBell/NotificationBell';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const { authenticated, name: userName } = useAuth();
  const [showInfo, setShowInfo] = useState(false);
  const { theme, toggle: toggleTheme } = useTheme();
  const themeLabel = theme === THEMES.DARK ? 'Включить светлую тему' : 'Включить ночную тему';
  const infoRef = useRef(null);

  const handleLogout = () => {
    // Чистим сессию и оповещаем; RequireAuth сам уводит на /login.
    logout();
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (infoRef.current && !infoRef.current.contains(e.target)) {
        setShowInfo(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="site-header">
      <div className="site-header__left">
        <Link to="/cameras" className="site-header__logo"><span className="brand-num">24</span>inspector</Link>
      </div>
      <div className="site-header__right">
        {authenticated ? (
          <>
            <NotificationBell />
            <span className="site-header__user">{userName}</span>
            <button className="site-header__btn site-header__btn--logout" onClick={handleLogout}>
              Выйти
            </button>
          </>
        ) : (
          <>
            <button className="site-header__btn site-header__btn--login" onClick={() => navigate('/login')}>Войти</button>
            <button className="site-header__btn site-header__btn--register" onClick={() => navigate('/register')}>Регистрация</button>
          </>
        )}
        <button
          type="button"
          className="site-header__theme-btn"
          onClick={toggleTheme}
          title={themeLabel}
          aria-label={themeLabel}
          aria-pressed={theme === THEMES.DARK}
        >
          {theme === THEMES.DARK ? <Sun width={16} height={16} /> : <Moon width={16} height={16} />}
        </button>
        <div className="site-header__info" ref={infoRef}>
          <button
            className="site-header__info-btn"
            onClick={() => setShowInfo((v) => !v)}
            title="Информация"
          >
            ?
          </button>
          {showInfo && (
            <div className="site-header__info-popup">
              <a href={OFERTA_PDF_PATH} target="_blank" rel="noopener noreferrer">
                Публичная оферта
              </a>
              <a href="/docs/Политика_ПД_27.05.2026 - 1.pdf" target="_blank" rel="noopener noreferrer">
                Политика обработки персональных данных
              </a>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
